import styled from "@emotion/styled";

import { IconButton } from "../../buttons/index.ts";
import { FONT_WEIGHT_BOLD } from "../../utilities/constants.ts";
import { withDataTest } from "../../utilities/index.ts";

const StyledSidebarSectionContainer = styled.div`
  display: flex;

  flex-direction: column;

  width: 100%;
  height: 100%;

  color: ${({ theme }) => theme.generalTextIcon};

  background-color: ${({ theme }) => theme.surface};

  border-right: ${({ theme }) => `1px solid ${theme.surfaceBack_1}`};
`;

export const SidebarSectionContainer = withDataTest(StyledSidebarSectionContainer, "panel-container");

const StyledSidebarSectionCloseButton = styled(IconButton)`
  margin-left: -10px;
  margin-right: 10px;
`;

export const SidebarSectionCloseButton = withDataTest(StyledSidebarSectionCloseButton, "panel-close-button");

const StyledSidebarSectionHeading = styled.div`
  font-size: ${({ theme }) => theme.fontSize};
  font-weight: ${FONT_WEIGHT_BOLD};
  line-height: 1.5rem;
  display: grid;
  grid-template-columns: 1fr 24px; // Allow a column for loading indicator.
`;

export const SidebarSectionHeading = withDataTest(StyledSidebarSectionHeading, "content-heading");

const StyledSidebarSectionTitle = styled.div`
  display: flex;

  align-items: center;
  justify-content: space-between;

  ${StyledSidebarSectionHeading} {
    flex: 1 1 100%;
  }

  ${StyledSidebarSectionCloseButton} {
    flex: 0 0 auto;
  }
`;

export const SidebarSectionTitle = withDataTest(StyledSidebarSectionTitle, "panel-title");

const StyledSidebarSectionDescription = styled.p`
  margin: 4px 0;

  color: ${({ theme }) => theme.generalTextIcon};

  font-size: ${({ theme }) => theme.fontSizeSmall};
  line-height: 1rem;
`;

export const SidebarSectionDescription = withDataTest(StyledSidebarSectionDescription, "panel-description");

export const SidebarSectionContentDescription = styled.p`
  margin: 4px 0;

  color: ${({ theme }) => theme.generalTextIcon};

  font-size: ${({ theme }) => theme.fontSizeSmall};
  line-height: 1rem;
`;

export const SidebarSectionHeader = styled.div`
  display: flex;
  flex-direction: column;

  min-height: 80px;

  background-color: ${({ theme }) => theme.surfaceBack_2};
  color: ${({ theme }) => theme.generalTextIcon};

  padding: 15px;
  flex: 0 0 auto;
`;

export const SidebarSectionContent = styled.div`
  overflow-y: auto;
  height: 100%;
  font-size: ${({ theme }) => theme.fontSizeSmall};
`;
